import { defineComponent } from 'vue';
import Faq02Image from '@/assets/image/faq/faq02.png';
import Faq03Image from '@/assets/image/faq/faq03.png';
export default defineComponent({
  name: 'FaqQECIT',
  setup: function () {
    return {
      Faq02Image: Faq02Image,
      Faq03Image: Faq03Image
    };
  }
});